import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { DropdownItem } from 'components/forms/Dropdown';

/**
 * Génère 12 entrées "01 janvier" → "01 décembre" pour les sélecteurs d'échéance.
 * `key` est le numéro du mois (1-12), `label` le libellé formaté FR.
 */
export function generateMonthlyDropdown(): DropdownItem<number>[] {
  const items: DropdownItem<number>[] = [];
  const startDate = new Date(new Date().getFullYear(), 0, 1); // 1er janvier de l'année courante
  for (let i = 0; i < 12; i++) {
    const date = new Date(startDate);
    date.setMonth(i);
    items.push({
      key: parseInt(format(date, 'M'), 10),
      label: format(date, 'dd MMMM', { locale: fr }),
    });
  }
  return items;
}
